import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot,} from "@angular/router";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {RolesEnum} from "app/shared/models/Roles";
import {AuthService} from "../services/auth/auth.service";

@Injectable({providedIn: "root"})
export class ProjectGuard implements CanActivate {
  constructor(
    private router: Router,
    private _authService: AuthService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return this._authService.isLoggedIn()
      .pipe(
        map(loggedIn => {

          if (loggedIn) {

            const roles = this._authService.currentUser().roles;
            if (roles.includes(RolesEnum.PROJECT_ADMIN) ||
              (roles.includes(RolesEnum.SUPER_ADMIN))
              || roles.includes(RolesEnum.PROGRAM_ADMIN)) {
              return true;
            } else {

              this.router.navigate(["/unauthorized"],
                {
                  queryParams: {returnUrl: state.url},
                }
              );
              return false;
            }

          } else {
            this.router.navigate(['/account/login'], {queryParams: {returnUrl: state.url}});
            return false;

          }

        }));

  }
}
